<app-dynamic-form [fields]="fields" [formGroup]="form" [isParent]="false"></app-dynamic-form>

<app-button-group>
  <button [mat-dialog-close]="form" color="primary" mat-stroked-button>{{ 'COMMON.save' | translate }}</button>
  <button mat-dialog-close color="warn" mat-stroked-button>{{ 'QUERY_BUILDER.close' | translate }}</button>
</app-button-group>
